import Rest from '../../Rest'

export default class ReportingChannelWorkflowDestinationService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/reporting_channel_handling/config'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  addDestination(configId: Number, data: any = null) {
    return this.post(`/${configId}/destinations`, {
      destinations: data
    })
  }

  deleteDestination(configId: Number, destinationId: Number) {
    return this.delete(`/${configId}/destinations/${destinationId}`)
  }
}
